import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { SignUpComponent } from './sign-up/sign-up.component';
import { ForgotPasswordComponent } from './authentication/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './authentication/reset-password/reset-password.component';
import { AuthGuard } from './_helpers';
import { NewsComponent } from './news/news.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { TermsComponent } from './terms/terms.component';

const routes: Routes = [
    { path: '', component: HomeComponent },  //, canActivate: [AuthGuard]
    { path: 'news', component: NewsComponent },
    { path: 'terms', component: TermsComponent },
    { path: 'notifications', component: NotificationsComponent },
    { path: 'login', component: LoginComponent },
    { path: 'signup/:cat',component:SignUpComponent},
    { path: 'forgotpassword', component: ForgotPasswordComponent },
    { path: 'resetpassword', component: ResetPasswordComponent },
    { path: 'general', loadChildren:()=> import('./general/general.module').then(m => m.GeneralModule) },
    { path: 'profile', loadChildren:()=> import('./Profile-module/profile.module').then(m=> m.ProfileModule)},
    { path: 'pg',loadChildren:()=> import('./purchaseGroup/purchase-group.module').then(m=> m.PurchaseGroupModule)},
    { path: 'auction', loadChildren: ()=>import('./auction-module/auction-module.module').then(m=> m.AuctionModule)},
    { path: 'lottery', loadChildren: ()=>import('./lottery/lottery-module.module').then(m=> m.LotteryModule)},
    { path: 'agents', loadChildren: ()=>import('./agents/agents.module').then(m=> m.AgentsModule)},
    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true,relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
